import React, {Component} from 'react';
import Get from '../components/Get';
import MoreBottomTab from '../MoreBottomTab';

export default class DepositHistory extends Component {
  constructor() {
    super();
    this.state = {
      rows: [],
      loading: false,
    };
  }

  componentDidMount() {
    this.getTransactions();
  }

  getTransactions = async () => {
    this.setState({loading: true});
    try {
      const res = await Get.Wallet('add_money');
      this.setState({loading: false});

      if (res.transection && res.transection.length > 0) {
        const flatTransactions = res.transection.flatMap(group => group.data);
        if (flatTransactions.length > 0) {
          const rows = flatTransactions.map((item, key) => (
            <div className="card-row" key={key}>
              <div className="row-top">
                <span className="message-text">{item.message}</span>
                <span className="date-text">{item.date}</span>
              </div>
              <div className="row-bottom">
                <span
                  className={`amount-text ${
                    item.status === 'process'
                      ? 'process'
                      : item.transection === 'debit'
                      ? 'debit'
                      : 'credit'
                  }`}>
                  {item.transection === 'debit' ? '-' : '+'}
                  {item.amount}
                </span>
                {item.status === 'process' && (
                  <span className="status-text">{item.status}</span>
                )}
              </div>
            </div>
          ));
          this.setState({rows});
        } else {
          this.setState({
            rows: (
              <div className="no-transaction">No Transaction Available</div>
            ),
          });
        }
      } else {
        this.setState({
          rows: <div className="no-transaction">No Transaction Available</div>,
        });
      }
    } catch (err) {
      this.setState({loading: false});
      console.error('Wallet Fetch Error:', err);
      alert('Failed to fetch transactions');
    }
  };

  render() {
    const {rows, loading} = this.state;

    return (
      <div className="deposit-history">
        <style>{`
          .deposit-history {
            min-height: 100vh;
            background-color: #f6f6f6;
            padding-bottom: 50px;
            font-family: Arial, sans-serif;
          }
          .header-bar {
            height: 60px;
            background-color: #00318b;
            display: flex;
            justify-content: center;
            align-items: center;
            border-bottom-left-radius: 20px;
            border-bottom-right-radius: 20px;
            color: #fff;
            font-weight: bold;
            font-size: 18px;
            margin-bottom: 20px;
          }
          .transactions {
            padding: 0 16px;
          }
          .card-row {
            background-color: rgba(29, 185, 120, 0.41);
            margin: 8px 0;
            padding: 16px;
            border-radius: 12px;
          }
          .row-top {
            display: flex;
            justify-content: space-between;
            margin-bottom: 8px;
          }
          .message-text {
            font-weight: bold;
            color: #333;
          }
          .date-text {
            color: #888;
            font-size: 12px;
          }
          .row-bottom {
            display: flex;
            justify-content: space-between;
            align-items: center;
          }
          .amount-text {
            font-weight: bold;
            font-size: 18px;
          }
          .amount-text.debit { color: red; }
          .amount-text.credit { color: green; }
          .amount-text.process { color: #ffc107; }
          .status-text { font-size: 12px; color: #999; }
          .no-transaction {
            text-align: center;
            margin: 50px 0;
            font-size: 16px;
            color: #555;
          }
          .overlay {
            position: fixed;
            top:0;
            left:0;
            right:0;
            bottom:0;
            background: rgba(0,0,0,0.6);
            color: white;
            display: flex;
            align-items: center;
            justify-content: center;
            font-size: 20px;
            z-index: 1000;
          }
        `}</style>

        {loading && <div className="overlay">Loading...</div>}

        <div className="header-bar">
          <span>Deposit History</span>
        </div>
        <div className="transactions">{rows}</div>
        <MoreBottomTab />
      </div>
    );
  }
}
